import {
  GET_SUMMARY,
  GET_SUMMARY_ERROR,
  GET_SUMMARY_LOADING,
} from 'src/action-creators/journey-touchpoint';

import type {JourneyTouchpointActions} from 'src/action-creators/journey-touchpoint';
import type {TouchpointSummaryResponseData} from 'src/types/journey-touchpoint';


export type JourneyTouchpointState = {
  summaryData: TouchpointSummaryResponseData | null | undefined;
  summaryDataLoading: boolean;
  summaryDataError: unknown;
};

const initialState: JourneyTouchpointState = {
  summaryData: null,
  summaryDataLoading: false,
  summaryDataError: null,
};

export default (
  state: JourneyTouchpointState | null | undefined = initialState,
  action: JourneyTouchpointActions,
): JourneyTouchpointState => {
  switch (action.type) {
    case GET_SUMMARY:
      return {
        ...state,
        summaryData: action.payload,
        summaryDataLoading: false,
        summaryDataError: null,
      };
    case GET_SUMMARY_ERROR:
      // @ts-expect-error - TS2322 - Type '{ summaryDataError: { error: string; }; summaryDataLoading: false; summaryData?: TouchpointSummaryResponseData | null | undefined; }' is not assignable to type 'JourneyTouchpointState'.
      return {
        ...state,
        summaryDataError: action.payload,
        summaryDataLoading: false,
      };
    // @ts-expect-error - TS2678 - Type '"journey-touchpoint/get-summary-loading"' is not comparable to type '"journey-touchpoint/get-summary" | "journey-touchpoint/get-summary-error"'.
    case GET_SUMMARY_LOADING:
      // @ts-expect-error - TS2322 - Type '{ summaryDataLoading: true; summaryData?: TouchpointSummaryResponseData | null | undefined; summaryDataError?: unknown; }' is not assignable to type 'JourneyTouchpointState'.
      return {
        ...state,
        summaryDataLoading: true,
      };
  }
  // @ts-expect-error - TS2322 - Type 'JourneyTouchpointState | null' is not assignable to type 'JourneyTouchpointState'.
  return state;
};
